// extracted by mini-css-extract-plugin
export default {"cardListStyle":"CardList_cardListStyle__dsHpC","cardListColStyle":"CardList_cardListColStyle__HHl-K"};